import React from 'react';
import { COMPANY_NAME } from '../constants';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white p-4 text-center mt-auto">
      <p>© {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
